(() => {
  function init(root) {
    root.querySelectorAll('[data-ln-gallery]').forEach((gallery) => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const track = gallery.querySelector('[data-gallery-track]');
      const slides = [...track.querySelectorAll('[data-gallery-slide]')];
      if (!slides.length) return;
      const prev = gallery.querySelector('[data-gallery-prev]');
      const next = gallery.querySelector('[data-gallery-next]');
      const counter = gallery.querySelector('[data-gallery-count]');
      let current = 0;
      const sync = () => {
        const left = track.getBoundingClientRect().left;
        current = slides.reduce((best, slide, i) => Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(slides[best].getBoundingClientRect().left - left) ? i : best, 0);
        counter.textContent = `${current + 1} / ${slides.length}`;
        prev.disabled = current === 0;
        next.disabled = current === slides.length - 1;
      };
      const go = (index) => {
        index = Math.max(0, Math.min(slides.length - 1, index));
        const left = slides[index].getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
        track.scrollTo({left, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      prev.addEventListener('click', () => go(current - 1));
      next.addEventListener('click', () => go(current + 1));
      track.addEventListener('scroll', sync, {passive: true});
      track.addEventListener('keydown', (event) => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        go(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : current + (event.key === 'ArrowRight' ? 1 : -1));
      });
      gallery.addEventListener('shopify:block:select', (event) => {
        const index = slides.findIndex(slide => slide === event.target || slide.contains(event.target));
        if (index >= 0) go(index);
      });
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
